import React, { useEffect } from 'react';
import {
  useParams,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { env } from '../../../config';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import PageHttp from '~/commons/components/PageHttp.jsx';
import FormAdmin from '../../forms/FormAdmin.jsx';
import { getLang } from '~/commons/helpers';

const PageSchoolAdmin = () => {
  const { _id, adminId } = useParams();
  const [schoolRes, schoolReq] = useHttpStatus();
  const [schoolClassRes, schoolClassReq] = useHttpStatus();
  const [adminRes, adminReq] = useHttpStatus();
  const { t, i18n: { language } } = useTranslation();
  const schoolClassParam = {
    filter: { school: _id },
    sort: { title: 1 },
  };

  useEffect(() => {
    schoolReq({ url: `/api/core/schools/${_id}` });
    schoolClassReq({ url: '/api/core/schoolclasses', params: schoolClassParam });

    if (adminId !== 'new') {
      adminReq({ url: `/api/core/users/admins/${adminId}` });
    }
  }, [_id, adminId]);

  const res = [schoolRes, schoolClassRes];

  if (adminId !== 'new') {
    res.push(adminRes);
  }

  return (
    <PageHttp res={res}>
      {([school, schoolClass, admin]) => {
        const breadcrumb = [
          { to: '../../', children: getLang(school.title, language) },
        ];
        if (env.user.roles.includes('admin')) {
          breadcrumb.unshift(
            { to: '../../../', children: 'Schools' },
          );
        }

        return adminId === 'new' ? (
          <>
            <Header breadcrumb={breadcrumb}>{`${t('New ')}${t('School Admin')}`}</Header>
            <FormAdmin school={school} schoolClass={schoolClass}/>
          </>
        ) : (
          <>
            <Header breadcrumb={breadcrumb}>{`${t('Edit ')}${t('School Admin')}`}</Header>
            <FormAdmin
              school={school}
              admin={admin}
              schoolClass={schoolClass}
            />
          </>
        );
      }}
    </PageHttp>
  );
};

export default PageSchoolAdmin;
